import React, {useState} from 'react';
import {Button} from '@flixbus/honeycomb-react';
import {Icon, IconDownload} from '@flixbus/honeycomb-icons-react';
import {isNotNilOrEmpty} from 'ramda-adjunct';
import {acquireAccessToken} from '@/Pages/Auth/auth.config.ts';
import {getUnitsSystemFromLocalStorage} from '../../../Common/LocalUnits';

const DownloadAnalyticsViewButton = ({
  name,
  searchFilters,
  endPointName,
  fileName,
  selectedRows
}) => {
  const [loading, setLoading] = useState(false);
  const url = `${import.meta.env.VITE_API_URL}/api/v1/${endPointName}?`;

  const getSearchParams = () => {
    const searchParamsJson = {};

    if (isNotNilOrEmpty(selectedRows)) {
      searchParamsJson['productionCostAnalyticsViewEntryIds'] = selectedRows;
    }

    if (isNotNilOrEmpty(searchFilters.busPartnerIds)) {
      searchParamsJson['busPartners'] = searchFilters.busPartnerIds;
    }

    if (isNotNilOrEmpty(searchFilters.lineNumbers)) {
      searchParamsJson['lines'] = searchFilters.lineNumbers;
    }

    if (isNotNilOrEmpty(searchFilters.countryIds)) {
      searchParamsJson['countries'] = searchFilters.countryIds;
    }

    if (isNotNilOrEmpty(searchFilters.name)) {
      searchParamsJson['name'] = searchFilters.name;
    }

    if (isNotNilOrEmpty(searchFilters.statuses)) {
      searchParamsJson['statuses'] = searchFilters.statuses;
    }

    if (isNotNilOrEmpty(searchFilters.origins)) {
      searchParamsJson['origins'] = searchFilters.origins;
    }

    if (searchFilters.planningPeriods?.startDate) {
      searchParamsJson['startDate'] = new Date(
        searchFilters.planningPeriods.startDate
      )
        .toISOString()
        .substring(0, 10);
    }

    if (searchFilters.planningPeriods?.endDate) {
      searchParamsJson['endDate'] = new Date(
        searchFilters.planningPeriods?.endDate
      )
        .toISOString()
        .substring(0, 10);
    }
    return searchParamsJson;
  };

  const getOptions = async () => {
    const authToken = await acquireAccessToken();
    const unitsSystem = getUnitsSystemFromLocalStorage();

    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'units-system': unitsSystem,
        Authorization: authToken ? `Bearer ${authToken}` : null
      },
      body: JSON.stringify(getSearchParams())
    };
  };

  const handleStatus = result => {
    if (!result.ok) {
      throw new Error(result.statusText);
    }
    return result;
  };

  const handleBlobContent = blob => {
    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob], {type: 'xlsx'}));
    const link = document.createElement('a');
    link.href = url;

    const dateTime = new Date()
      .toISOString()
      .replace(/[^0-9]/g, '')
      .slice(0, -3);
    const fileNameWithDate = `${fileName}_${dateTime}.xlsx`;
    link.setAttribute('download', fileNameWithDate);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const downloadAnalyticsData = async () => {
    setLoading(true);

    const options = await getOptions();
    fetch(url, options)
      .then(handleStatus)
      .then(response => response.blob())
      .then(handleBlobContent)
      .catch(error => console.error('Error downloading analytics data', error))
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Button
        onClick={() => downloadAnalyticsData()}
        loading={loading}
        disabled={loading}
      >
        <Icon InlineIcon={IconDownload} aria-hidden="true" />
        <span style={{fontSize: 'smaller'}}>{name}</span>
      </Button>
    </div>
  );
};
export default React.memo(DownloadAnalyticsViewButton);
